<template>
  <div id="app">
    <!-- Top Route Navigation Progress Bar -->
    <transition name="fade">
      <div v-if="isNavigating" class="stella-route-progress-bar"></div>
    </transition>

    <!-- PWA Update Banner -->
    <transition name="fade">
      <div v-if="updateAvailable" class="stella-pwa-update-banner">
        <div class="d-flex align-items-center justify-content-between w-100 px-3 py-2">
          <div class="d-flex align-items-center">
            <span class="me-2" style="font-size: 18px;">✨</span>
            <span class="font-size-13 text-white font-weight-500">A new version of Stella is ready</span>
          </div>
          <button type="button" class="cp-btn-primary font-size-12 px-3 py-1" @click="refreshApp()">
            Update <i class="fa fa-refresh ms-1"></i>
          </button>
        </div>
      </div>
    </transition>

    <router-view :key="$route.fullPath"></router-view>
    <toast-notification ref="globalToast" />
    <scroll-shortcut />
  </div>
</template>

<script>
import ToastNotification from "@/components/module/shared/ToastNotification";
import ScrollShortcut from "@/components/module/shared/ScrollShortcut";
import { mapGetters, mapMutations } from "vuex";
import * as messageService from "@/common/message-service";
import { routerEventBus } from "@/common/event-bus";

export default {
  name: 'app',
  components: {
    ToastNotification,
    ScrollShortcut
  },
  data() {
    return {
      enable: false,
      updateAvailable: false,
      registration: null,
      isNavigating: false,
      navTimeout: null
    }
  },
  computed: {
    ...mapGetters(['globalErrors', 'getMessage', 'getWarning']),
  },
  methods: {
    ...mapMutations(['clearGlobalErrors']),
    getMsg(messageObj) {
      if (!messageObj) return '';
      if (typeof messageObj === 'string') {
        return messageService.getMessage(messageObj) || messageObj;
      }
      let msg = messageService.getMessage(messageObj.code);
      if (!msg) {
        msg = messageService.getMessage(messageObj.defaultMessage) || messageObj.defaultMessage || messageObj.code || String(messageObj);
      }
      if (messageObj.arguments && messageObj.arguments.length !== 0) {
        msg = messageService.replaceMsgWithArgs(msg, messageObj.arguments);
      }
      return msg || 'An error occurred';
    },
    onSwUpdated(e) {
      this.registration = e.detail;
      this.updateAvailable = true;
    },
    refreshApp() {
      this.updateAvailable = false;
      if (this.registration && this.registration.waiting) {
        this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    }
  },
  watch: {
    globalErrors(errors) {
      if (errors && errors.length > 0) {
        const lastErr = errors[errors.length - 1];
        this.$refs.globalToast.show(this.getMsg(lastErr), 'error', 4000);
      }
    },
    getMessage(msg) {
      if (msg) {
        this.$refs.globalToast.show(this.getMsg(msg), 'success', 3000);
      }
    },
    getWarning(msg) {
      if (msg) {
        this.$refs.globalToast.show(this.getMsg(msg), 'warning', 3500);
      }
    }
  },
  created() {
    document.addEventListener('swUpdated', this.onSwUpdated, { once: true });
    routerEventBus.$on('route-loading-start', () => {
      this.isNavigating = true;
      clearTimeout(this.navTimeout);
    });
    routerEventBus.$on('route-loading-end', () => {
      this.navTimeout = setTimeout(() => {
        this.isNavigating = false;
      }, 250);
    });
  },
  beforeDestroy() {
    document.removeEventListener('swUpdated', this.onSwUpdated);
    routerEventBus.$off('route-loading-start');
    routerEventBus.$off('route-loading-end');
    clearTimeout(this.navTimeout);
  }
}
</script>

